import React, { useState, useEffect } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Select from "react-select";
import { useFormik } from 'formik';
import { getCCCustomHouseList, getCCEmployeeList, getCCPortList } from '../../../../../../Redux/action/CustomClearance/CCAction';
import { useNavigate } from 'react-router-dom';
import { adminMainUrl } from '../../../../../../Config';
import axios from 'axios';
import { convertDateTimeToAPIFormatInCustomClearanceJobOrder, convertDateYYYYMMDDToDDMMYYYY, convertToDatetimeLocalFormatInJobOrderTransport } from '../../../../../../HelperFunctions';

const ImportJobAddNew = ({ accessedModules, accessedPermission }) => {


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [disableSubmit, setDisableSubmit] = useState(false);

    //REACT- SELECT STYLE
    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id')
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    useEffect(() => {
        if (token && user_id) {
            dispatch(getCCPortList(token, user_id));
            dispatch(getCCCustomHouseList(token, user_id));
            dispatch(getCCEmployeeList(token, user_id));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id])


    const {
        loadingCCPortList,
        CCPortListDataError,
        CCPortListData,

        loadingCCCustomHouseList,
        CCCustomHouseListData,
        CCCustomHouseListDataError,

        loadingCCEmployeeList,
        CCEmployeeListData,
        CCEmployeeListDataError,
    } = useSelector(state => state?.CCReducer);


    const [portOptions, setPortOptions] = useState([]);
    useEffect(() => {
        if (CCPortListData) {
            let arr = [];
            CCPortListData.map((val) => arr.push({ value: val.id, label: `${val.name} (${val.port_type})` }));
            setPortOptions(arr);
        }
    }, [loadingCCPortList, CCPortListDataError, CCPortListData])


    const [customHouseOptions, setCustomHouseOptions] = useState([]);
    useEffect(() => {
        if (CCCustomHouseListData) {
            let arr = [];
            CCCustomHouseListData.map((val) => arr.push({ value: val.id, label: val.name }));
            setCustomHouseOptions(arr);
        }
    }, [loadingCCCustomHouseList, CCCustomHouseListDataError, CCCustomHouseListData])

    const [employeeOptions, setEmployeeOptions] = useState([]);
    useEffect(() => {
        if (CCEmployeeListData) {
            let arr = [];
            CCEmployeeListData.map((val) => arr.push({ value: Number(val.user_id), label: val.name }));
            setEmployeeOptions(arr);
        }
    }, [loadingCCEmployeeList, CCEmployeeListDataError, CCEmployeeListData])


    const initialValues = {
        job_date_input: "",
        job_received_on_input: "",
        filing_mode_type: "",
        filing_mode_name: "",
        transport_mode: "",
        custom_house_id: "",
        job_owner_id: "",
        loading_port_id: "",
        s_b_type: "",
        consignment_type: "",
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }

                if (values.job_date_input) { values.job_date = values.job_date_input };
                if (values.job_received_on_input) { values.job_received_on = convertDateTimeToAPIFormatInCustomClearanceJobOrder(values.job_received_on_input) }
                axios.post(`${adminMainUrl}/api/customClearance/import/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            // refresh();
                            navigate(`/flexichain/custom-clearance/import-job/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error!";
                        if (error.response && error.response.data && error.response.data.msg) {
                            msg = error.response.data.msg
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    const [showICEgateIDinput, setShowICEgateIDinput] = useState(false);
    useEffect(() => {
        if (formik.values.filing_mode_type == "ICEGATE") {
            setShowICEgateIDinput(true);
        } else {
            setShowICEgateIDinput(false);
        }
    }, [formik.values.filing_mode_type])


    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">

                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Import Job Add
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="card">

                        <div className="card-body">

                            {/* Filter */}
                            <form onSubmit={formik.handleSubmit}>
                                <div className="d-flex align-items-end justify-content-between flex-wrap row-gap-2 mb-3">
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                        <div className="row">

                                            <div className="col-md-6 mt-2">
                                                <div className=''>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Job Date
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            name='job_date_input'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.job_date_input}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className=''>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Job Recieved On
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input
                                                            type="datetime-local"
                                                            className="form-control form-control-sm"
                                                            name='job_received_on_input'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.job_received_on_input}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className=''>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Filing Mode
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <div className="d-flex gap-2">
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="filing_mode_type"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.filing_mode_type}
                                                            >
                                                                <option value="" disabled>-</option>
                                                                <option value="ICEGATE">ICEGATE</option>
                                                                <option value="Manual">Manual</option>
                                                                <option value="SEZ">SEZ</option>
                                                                <option value="Service Center">Service Center</option>
                                                            </select>
                                                            {showICEgateIDinput && <input type="text" className="form-control form-control-sm"
                                                                id="filing_mode_name"
                                                                name="filing_mode_name"
                                                                placeholder='Enter ICE Gate ID'
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.filing_mode_name}
                                                            />}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className=''>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Transport Mode
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">

                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="transport_mode"
                                                            name="transport_mode"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.transport_mode}
                                                        >
                                                            <option value="" disabled>-</option>
                                                            <option value="Air">Air</option>
                                                            <option value="Sea">Sea</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 mt-2">
                                                <div className=''>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Custom House
                                                    </label>
                                                    <Select
                                                        className='custom-selector'
                                                        options={customHouseOptions}
                                                        styles={customStyles}
                                                        name="custom_house_id"
                                                        onChange={option => {
                                                            formik.setFieldValue('custom_house_id', option.value);
                                                        }}
                                                        value={customHouseOptions.find(option => option.value === formik.values.custom_house_id) || null}
                                                        isLoading={loadingCCCustomHouseList}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Job Owner
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={employeeOptions}
                                                            styles={customStyles}
                                                            name="job_owner_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('job_owner_id', option.value);
                                                            }}
                                                            value={employeeOptions.find(option => option.value === formik.values.job_owner_id) || null}
                                                            isLoading={loadingCCEmployeeList}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div >
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Loading Port
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={portOptions}
                                                            styles={customStyles}
                                                            name="loading_port_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('loading_port_id', option.value);
                                                            }}
                                                            value={portOptions.find(option => option.value === formik.values.loading_port_id) || null}
                                                            isLoading={loadingCCPortList}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 mt-2">
                                                <div className=''>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        S/B Type
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select className="form-control form-control-sm"
                                                            id="s_b_type"
                                                            name="s_b_type"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.s_b_type}
                                                        >
                                                            <option value="" disabled>-</option>
                                                            <option value="White-Free/DEEC">White-Free/DEEC</option>
                                                            <option value="Green-Drawback">Green-Drawback</option>
                                                            <option value="Blue-DEBP">Blue-DEBP</option>
                                                            <option value="Yellow-Dutiable">Yellow-Dutiable</option>
                                                            <option value="Pink-ExBond">Pink-ExBond</option>
                                                            <option value="SEZ-Regular">SEZ-Regular</option>
                                                            <option value="SEZ-ExBond">SEZ-ExBond</option>
                                                            <option value="SEZ-DTA Procurement">SEZ-DTA Procurement</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {formik.values.transport_mode == "Sea" && <div className="col-md-6 mt-2">
                                                <div className=''>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Consignment Type
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select className="form-control form-control-sm"
                                                            id="consignment_type"
                                                            name="consignment_type"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.consignment_type}
                                                        >
                                                            <option value="" disabled>-</option>
                                                            <option value="LCL">LCL</option>
                                                            <option value="FCL">FCL</option>
                                                            <option value="Break Bulk">Break Bulk</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>}

                                        </div>
                                    </div>
                                </div>
                                <div className="row d-flex justify-content-end">
                                    <div className="col-md-6 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
        </>

    )
}

export default ImportJobAddNew